<script lang="ts" setup>
import { computed, type HTMLAttributes } from "vue";
import type { StepperTitleProps } from "reka-ui";
import { StepperTitle, useForwardProps } from "reka-ui";

const props = defineProps<StepperTitleProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <StepperTitle v-bind="forwarded" class="text-md whitespace-nowrap font-semibold">
    <slot />
  </StepperTitle>
</template>
